// AccToggleUI.js
import React from "react";
import { Box, Typography, Paper, Divider, Switch } from "@mui/material";
import toggleDescriptions from "./AccToggleDesc";

const AccToggleUI = ({ toggles, handleToggle, formatLabel }) => {
  const renderToggleBox = (key) => (
    <Paper
      key={key}
      sx={{
        p: 2,
        mb: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography fontWeight="bold">{formatLabel(key)}</Typography>
        <Switch
          checked={toggles[key]}
          onChange={() => handleToggle(key)}
          inputProps={{ "aria-label": `toggle ${key}` }}
        />
      </Box>
      {toggleDescriptions[key] && (
        <Typography variant="body2" color="text.secondary">
          {toggleDescriptions[key]}
        </Typography>
      )}
    </Paper>
  );

  const renderSection = (title, keys) => (
    <>
      <Box sx={{ display: "flex", alignItems: "center", my: 3 }}>
        <Divider sx={{ flex: 1 }} />
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          sx={{ mx: 2, whiteSpace: "nowrap" }}
        >
          {title}
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Box>
      {keys.map((key) =>
        toggles.hasOwnProperty(key) ? renderToggleBox(key) : null
      )}
    </>
  );

  return (
    <>
      {renderSection("Inventory Toggles", ["inventory", "out of stock"])}
      {renderSection("Charges Toggles", ["service charge"])}
      {renderSection("Functionalities Toggles", ["auto print kitchen", "auto print checked items kitchen", "foh gross sales", "boh gross sales"])}
    </>
  );
};

export default AccToggleUI;
